import { render, staticRenderFns } from "./ObjetivoCrianca.vue?vue&type=template&id=78af3916&scoped=true"
import script from "./ObjetivoCrianca.vue?vue&type=script&lang=js"
export * from "./ObjetivoCrianca.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoCrianca.vue?vue&type=style&index=0&id=78af3916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af3916",
  null
  
)

export default component.exports